import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { ModalDialogComponent, ModalDialogData, ModalDialogIcon, ModalResult } from '@app/shared/components/ui';

type ModalOptions = Partial<Omit<ModalDialogData, 'icon' | 'title' | 'message'>>;

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private readonly dialog = inject(MatDialog);

  async fire(
    icon: ModalDialogIcon,
    title: string,
    message: string,
    options: ModalOptions = {}
  ): Promise<ModalResult> {
    const dialogRef = this.dialog.open<
      ModalDialogComponent,
      ModalDialogData,
      'confirm' | 'cancel' | 'closed'
    >(ModalDialogComponent, {
      data: {
        icon,
        title,
        message,
        ...options,
      },
      panelClass: 'modal-dialog-panel',
    });

    const closeReason = await firstValueFrom(dialogRef.afterClosed());

    return {
      isConfirmed: closeReason === 'confirm',
      isCancelled: closeReason === 'cancel',
      isClosed: closeReason === 'closed',
    };
  }
}
